<script>
  export let tasks;
  import {
    DataTable,
    Form,
    FormGroup,
    DatePicker,
    DatePickerInput,
    RadioButtonGroup,
    RadioButton,
    Select,
    SelectItem,
    Button,
    Grid,
    Row,
    Column,
    Toolbar,
    ToolbarBatchActions,
    ToolbarContent,
  } from "carbon-components-svelte";
  import { updateTask } from "../store";
  import Plus from "svelte-bootstrap-icons/lib/Plus";
  import Dash from "svelte-bootstrap-icons/lib/Dash";
  import DelegateButton from "./DelegateButton.svelte";
  import DeferButton from "./DeferButton.svelte";
  import DoButton from "./DoButton.svelte";
  import DoneButton from "./DoneButton.svelte";
  import { projects } from "../services/project";
  import { contexts } from "../services/context";
  import { topics } from "../services/topic";
  import TrashCan16 from "carbon-icons-svelte/lib/TrashCan16";
    import DocumentAdd20 from "carbon-icons-svelte/lib/DocumentAdd20";
    import NextOutline20 from "carbon-icons-svelte/lib/NextOutline20";
    import FolderAdd20 from "carbon-icons-svelte/lib/FolderAdd20";

  let duedate;
  let selectedRowIds;
  let quickaddmodal;

  function updateTaskDates(data) {
        const date = new Date(duedate);
        data.nextaction = date;

        updateTask(data)
  }
</script>

<DataTable
  batchExpansion
  selectable bind:selectedRowIds
  sortable
  title="Next"
  description="What you should work on next:"
  headers={[
    { key: "name", value: "Name" },
    { key: "description", value: "Description" },
    { key: "status", value: "Status" },
    { key: "priority", value: "Priority" },
    { key: "nextaction", value: "NextAction" },
    { key: "buttons", value: "Action" },
  ]}
  rows={tasks}
>
<Toolbar>
  <ToolbarBatchActions>
      <Button icon={TrashCan16} on:click={() => (confirmDelete = true)}
          >Complete</Button
      >
      <Button icon={NextOutline20} on:click={() => (confirmDelete = true)}
        >Tomorrow</Button
    >
    <Button icon={FolderAdd20} on:click={() => (confirmDelete = true)}
      >Project</Button
  >
  </ToolbarBatchActions>
  <ToolbarContent>
      <Button
          icon={DocumentAdd20}
          aria-label="Quick add"
          on:click={() => (quickaddmodal = true)}>Quick Add</Button
      >
  </ToolbarContent>
</Toolbar>
  <div slot="expanded-row" let:row>
    <Form on:submit>
      <Grid fullWidth>
        <Row>
          <Column style="outline: 1px solid var(--cds-interactive-04)">
            <FormGroup legendText="Priority">
              <RadioButtonGroup name="radio-button-group" selected="normal">
                <RadioButton id="radio-1" value="low" labelText="Low" />
                <RadioButton id="radio-2" value="normal" labelText="Normal" />
                <RadioButton id="radio-4" value="high" labelText="High" />
              </RadioButtonGroup>
            </FormGroup>
          </Column>
          <Column style="outline: 1px solid var(--cds-interactive-04)" >
            <DatePicker datePickerType="single" bind:value={duedate} on:change flatpickrProps={{ static: true, position: "right", dateFormat: "Y-m-d" }} min-height:100vh>
              <DatePickerInput labelText="Next Action" placeholder="Y-m-d" />
            </DatePicker>
            </Column>
        </Row>
        <Row>
          <FormGroup>
            <Column style="outline: 1px solid var(--cds-interactive-04)">
              <Select id="select-2" labelText="Select Topic" selected="0" inline>
                <SelectItem value="0" text="None" />
                {#each $topics as topic}
                  <SelectItem value={topic.id} text={topic.name} />
                {/each}
              </Select>
            </Column>
            <Column style="outline: 1px solid var(--cds-interactive-04)">
              <Select id="select-context" labelText="Select Context" selected="0" inline>
                <SelectItem value="0" text="None" />
                {#each $contexts as context}
                  <SelectItem value={context.id} text={context.name} />
                {/each}
              </Select>
            </Column>
          </FormGroup>
        </Row>
      </Grid>
      <FormGroup>
        <Select icon={FolderAdd20} id="select-project" labelText="Select Project" selected="0">
          <SelectItem value="0" text="None"/>
          {#each $projects as project}
            <SelectItem value={project.id} text={project.name} />
          {/each}
        </Select>
      </FormGroup>
      <Button type="submit" on:click={updateTaskDates(row)}>Submit</Button>
    </Form>
  </div>
  <svelte:fragment slot="cell" let:row let:cell>
    {#if cell.key === "buttons"}
      <p class="white-space: nowrap;">
        <DoButton data={row} />
        <DeferButton data={row} />
        <DelegateButton data={row} />
        <DoneButton data={row} />
      </p>
      {:else if cell.key === "nextaction"}
      {#if cell.value === "undefined"}
      -
      {:else}
      {(cell.value)}
      {/if}
    {:else}
      <!--             <Plus/>
            {task.getPriority()}
            <Dash/> -->
      {cell.value}
    {/if}
  </svelte:fragment>
</DataTable>
